import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { StaffService } from '../staffs.service';
import * as staffActions from './staffs.actions'

@Injectable({
    providedIn: 'root'
})

export class StaffEffects {
    constructor(
        private actions$: Actions,
        private staffService: StaffService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

  fetchStaffs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(staffActions.fetchStaffs),
      exhaustMap((action) =>
        this.staffService
          .fetchStaffs(action.merchantId, action.skip, action.limit, action.filter, action.search)
          .pipe(
            exhaustMap((response: any) => [
                staffActions.fetchStaffsSuccess({ staffs: response.data}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(staffActions.fetchStaffsFailed())
            }
            )
          )
      )
    )
  );

  fetchStaff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(staffActions.fetchStaff),
      exhaustMap((action) =>
        this.staffService
          .fetchStaff(action.merchantId, action.staffId)
          .pipe(
            exhaustMap((response: any) => [
                staffActions.fetchStaffSuccess({ staff: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(staffActions.fetchStaffFailed())
            }
            )
          )
      )
    )
  );

  createStaff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(staffActions.createStaff),
      exhaustMap((action) =>
        this.staffService
          .createStaff(action.staffDto)
          .pipe(
            exhaustMap((response: any) => [
                staffActions.createStaffSuccess(response),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(staffActions.createStaffFailed())
            }
            )
          )
      )
    )
  );

  updateStaff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(staffActions.updateStaff),
      exhaustMap((action) =>
        this.staffService
          .updateStaff(action.staffDto, action.staffId)
          .pipe(
            exhaustMap((response: any) => [
                staffActions.updateStaffSuccess({response: response}),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.message, 'An error occured');
                return of(staffActions.updateStaffFailed())
            }
            )
          )
      )
    )
  );
}